import { ListItemIcon } from '@mui/material';

import { GDMListItemIconComponent } from './GDMListItemIcon.type';

/* TODO: Implement component using GDM default design */
const GDMListItemIcon: GDMListItemIconComponent = props => <ListItemIcon {...props} />;

export default GDMListItemIcon;
